module.exports = __webpack_public_path__ + "img/cursor-big.b5d1e17b.svg";